/* eslint-disable */ /**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 * instead, edit its related `.gql` file and recreate it with
 *
 * npm run codegen:mentor
 */

import * as Types from '../../types/mentor-gql';

import { api } from 'app/apis/mentor-gql-api';
export type MentorDash_GetMentorAgreementsQueryVariables = Types.Exact<{
  mentor_id: Types.Scalars['String']['input'];
}>;

export type MentorDash_GetMentorAgreementsQuery = {
  __typename?: 'Query';
  agreements?: Array<{
    __typename?: 'Agreement';
    id?: string | null;
    mentor_id?: string | null;
    role?: Types.Role | null;
    status?: Types.Status | null;
    date_signed?: any | null;
    pay_rate?: string | null;
    hours_per_month?: string | null;
    max_payments_per_month?: string | null;
    bonus?: string | null;
    created_at?: any | null;
    updated_at?: any | null;
    currency_override?: string | null;
  } | null> | null;
};

export const MentorDash_GetMentorAgreementsDocument = `
    query MentorDash_GetMentorAgreements($mentor_id: String!) {
  agreements(mentor_id: $mentor_id) {
    id
    mentor_id
    role
    status
    date_signed
    pay_rate
    hours_per_month
    max_payments_per_month
    bonus
    created_at
    updated_at
    currency_override
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    MentorDash_GetMentorAgreements: build.query<
      MentorDash_GetMentorAgreementsQuery,
      MentorDash_GetMentorAgreementsQueryVariables
    >({
      query: (variables) => ({ document: MentorDash_GetMentorAgreementsDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
